import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../../helpers/fackBackend_Helper";

function* purchaseInventoryResponse({ payload: { data } }) {
  try {
    const response = yield call( addData, "/API/V1/Inventory/PurchaseInventory", data, );
    if (response?.statusCode == 1200) {
      yield put(actions.purchaseInventorySuccess(response?.message));
    } else {
      yield put(actions.purchaseInventoryError(response?.message, response?.data));
    }
  } catch (error) {
    yield put(actions.purchaseInventoryError(error));
  }
}

function* getPurchaseSimListResponse({ payload: { data } }) {
  try {
    const response = yield call( addData, "/API/V1/Inventory/SimPurchaseList", data, );
    if (response?.statusCode == 1200) {
      yield put(actions.getPurchaseSimListSuccess(response?.data));
    } else {
      yield put(actions.getPurchaseSimListError(response?.message));
    }
  } catch (error) {
    yield put(actions.getPurchaseSimListError(error));
  }
}

function* getSimListResponse({ payload: { data } }) {
  try {
    console.log("Request Payload =>", data);
    const response = yield call(addData, '/API/V1/Inventory/SimList', data);
    // const response = {
    //   statusCode: 1200,
    //   data: [
    //     {
    //       SerialNumber: "1234567890123456719",
    //       CreatedDateTime: "2026-07-22 13:23:18",
    //       ExpireDate: "2026-07-22 07:42:57",
    //       PurchaseNumber: "PUACHE",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8001061023459189017",
    //       CreatedDateTime: "2026-07-21 12:43:29",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901061023409189017",
    //       CreatedDateTime: "2026-07-21 12:39:56",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901061023009189017",
    //       CreatedDateTime: "2026-07-21 12:36:47",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901391023489189817",
    //       CreatedDateTime: "2026-07-21 12:34:43",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901091023489189817",
    //       CreatedDateTime: "2026-07-21 12:33:04",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901091023489189017",
    //       CreatedDateTime: "2026-07-21 12:31:48",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901061023489189017",
    //       CreatedDateTime: "2026-07-21 12:30:05",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901061029459189017",
    //       CreatedDateTime: "2026-07-21 12:26:37",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901061023459189017",
    //       CreatedDateTime: "2026-07-21 12:19:07",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901061023456189017",
    //       CreatedDateTime: "2026-07-21 12:18:01",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901061123456189017",
    //       CreatedDateTime: "2026-07-21 12:13:46",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901261123456189017",
    //       CreatedDateTime: "2026-07-21 12:12:14",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901261123456789017",
    //       CreatedDateTime: "2026-07-21 12:11:32",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901261123456789012",
    //       CreatedDateTime: "2026-07-21 12:10:03",
    //       ExpireDate: "2026-07-21 06:38:52",
    //       PurchaseNumber: "PU1234567",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "1234567890123456789",
    //       CreatedDateTime: "2026-07-20 12:54:49",
    //       ExpireDate: "2027-12-31 00:00:00",
    //       PurchaseNumber: "PU260720125430",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "1234567890123456789",
    //       CreatedDateTime: "2026-07-20 12:54:49",
    //       ExpireDate: "2027-07-20 00:00:00",
    //       PurchaseNumber: "PU260720125430",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "5686868963006896897536",
    //       CreatedDateTime: "2026-07-16 17:39:15",
    //       ExpireDate: "2027-12-31 00:00:00",
    //       PurchaseNumber: "PUR00005",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "5686868963006896897536",
    //       CreatedDateTime: "2026-07-16 17:39:15",
    //       ExpireDate: "2026-07-16 12:05:25",
    //       PurchaseNumber: "PUR00005",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "568686896396896897536",
    //       CreatedDateTime: "2026-07-16 17:37:56",
    //       ExpireDate: "2026-07-16 12:05:25",
    //       PurchaseNumber: "PUR00005",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "568686896896896897536",
    //       CreatedDateTime: "2026-07-16 17:37:42",
    //       ExpireDate: "2026-07-16 12:05:25",
    //       PurchaseNumber: "PUR00005",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "568686896896896897576",
    //       CreatedDateTime: "2026-07-16 17:36:13",
    //       ExpireDate: "2026-07-16 12:05:25",
    //       PurchaseNumber: "PUR00004",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "12345678901233456789",
    //       CreatedDateTime: "2026-07-16 16:01:23",
    //       ExpireDate: "2026-07-16 10:28:27",
    //       PurchaseNumber: "PURUTL202607165889",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901260123456789013",
    //       CreatedDateTime: "2026-07-16 12:46:28",
    //       ExpireDate: "2026-07-16 07:15:37",
    //       PurchaseNumber: "PUR00002",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //     {
    //       SerialNumber: "8901260123456789012",
    //       CreatedDateTime: "2026-07-15 19:14:44",
    //       ExpireDate: "2026-07-15 13:43:38",
    //       PurchaseNumber: "PUR00001",
    //       InventoryStatus: "Available",
    //       SIMType: "eSIM",
    //     },
    //   ],
    //   message: "SIM List data fetched successfully.",
    // };
    console.log("API Response =>", response);
    if (response?.statusCode == 1200) {
      yield put(actions.getSimListSuccess(response?.data));
    } else {
      yield put(actions.getSimListError(response?.message));
    }
  } catch (error) {
    yield put(actions.getSimListError(error));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.PURCHASE_INVENTORY, purchaseInventoryResponse)]);
  yield all([ takeEvery(actions.GET_PURCHASE_SIM_LIST, getPurchaseSimListResponse), ]);
  yield all([takeEvery(actions.GET_SIM_LIST, getSimListResponse)]);
}
